(function () {
  var DEFAULT_AUTOPLAY_MS = 5000;
  var MIN_AUTOPLAY_MS = 1000;
  var MAX_AUTOPLAY_MS = 120000;

  function getAutoplayMs(root) {
    var raw = root.getAttribute('data-autoplay-ms');
    var n = parseInt(String(raw), 10);
    if (isNaN(n) || n < MIN_AUTOPLAY_MS) return DEFAULT_AUTOPLAY_MS;
    if (n > MAX_AUTOPLAY_MS) return MAX_AUTOPLAY_MS;
    return n;
  }

  function postYouTubeCommand(iframe, command) {
    if (!iframe || !iframe.contentWindow) return;
    try {
      iframe.contentWindow.postMessage(
        JSON.stringify({ event: 'command', func: command, args: [] }),
        'https://www.youtube.com'
      );
    } catch (e) {}
  }

  function postVimeoMethod(iframe, method) {
    if (!iframe || !iframe.contentWindow) return;
    try {
      iframe.contentWindow.postMessage(JSON.stringify({ method: method }), '*');
    } catch (e) {}
  }

  function syncTileMedia(root) {
    var allTiles = root.querySelectorAll('[data-media-switch-tile]');
    for (var i = 0; i < allTiles.length; i++) {
      var tile = allTiles[i];
      var isActive = tile.classList.contains('is-active');
      var v = tile.querySelector('video');
      if (v) {
        if (isActive) {
          try {
            v.muted = true;
            v.currentTime = 0;
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } catch (e) {}
        } else {
          try {
            v.pause();
          } catch (e) {}
        }
        continue;
      }
      var yt = tile.querySelector('iframe.js-youtube');
      if (yt) {
        postYouTubeCommand(yt, isActive ? 'playVideo' : 'pauseVideo');
        continue;
      }
      var vi = tile.querySelector('iframe.js-vimeo');
      if (vi) {
        postVimeoMethod(vi, isActive ? 'play' : 'pause');
      }
    }
  }

  function pauseAllVideoLike(root) {
    var allTiles = root.querySelectorAll('[data-media-switch-tile]');
    for (var i = 0; i < allTiles.length; i++) {
      var tile = allTiles[i];
      var v = tile.querySelector('video');
      if (v) {
        try {
          v.pause();
        } catch (e) {}
        continue;
      }
      var yt = tile.querySelector('iframe.js-youtube');
      if (yt) {
        postYouTubeCommand(yt, 'pauseVideo');
        continue;
      }
      var vi = tile.querySelector('iframe.js-vimeo');
      if (vi) postVimeoMethod(vi, 'pause');
    }
  }

  function scheduleSyncActiveMedia(root) {
    function doSync() {
      syncTileMedia(root);
    }
    var hasIframe = root.querySelector('iframe.js-youtube, iframe.js-vimeo');
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(function () {
        window.setTimeout(doSync, hasIframe ? 150 : 0);
      });
    } else {
      window.setTimeout(doSync, hasIframe ? 150 : 0);
    }
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function syncProductVideoTabindex(root) {
    if (!root || !root.querySelectorAll) return;
    var hits = root.querySelectorAll('.media-switch__video-product-hit');
    for (var h = 0; h < hits.length; h++) {
      var el = hits[h];
      var tile = el.closest('.media-switch__tile');
      el.setAttribute('tabindex', tile && tile.classList.contains('is-active') ? '0' : '-1');
    }
  }

  function getScrollY() {
    return (
      window.scrollY ||
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0
    );
  }

  function init(root) {
    if (!root || root.dataset.mediaSwitchReady) return;
    root.dataset.mediaSwitchReady = 'true';

    var sectionEl = root.closest('.media-switch');
    var canSwitchAnim = false;
    var tiles = root.querySelectorAll('[data-media-switch-tile]');
    var tileCount = tiles.length;
    var autoplayUnlocked = getScrollY() > 0;

    function unlockAutoplay() {
      if (autoplayUnlocked) return;
      autoplayUnlocked = true;
      if (root._mediaSwitchViewportIo) {
        try {
          root._mediaSwitchViewportIo.disconnect();
        } catch (e) {}
        root._mediaSwitchViewportIo = null;
      }
      if (root._mediaSwitchScrollUnlock) {
        window.removeEventListener('scroll', root._mediaSwitchScrollUnlock);
        root._mediaSwitchScrollUnlock = null;
      }
      startAutoplay();
    }

    function entranceDoneMs() {
      if (!sectionEl || tileCount === 0) return 0;
      var cs = window.getComputedStyle(sectionEl);
      var stagger = parseFloat(cs.getPropertyValue('--ms-entrance-stagger')) || 0.26;
      var dur = parseFloat(cs.getPropertyValue('--ms-entrance-tile-duration')) || 0.85;
      return Math.ceil((Math.max(0, tileCount - 1) * stagger + dur) * 1000) + 100;
    }

    function finishEntrance() {
      if (sectionEl) sectionEl.classList.add('media-switch--entrance-done');
      canSwitchAnim = true;
    }

    function revealEntrance() {
      if (!sectionEl) {
        finishEntrance();
        return;
      }
      if (prefersReducedMotion()) {
        sectionEl.classList.add('media-switch--ready', 'media-switch--entrance-done');
        canSwitchAnim = true;
        return;
      }
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          sectionEl.classList.add('media-switch--ready');
          if (root._entranceDoneTimeout) {
            window.clearTimeout(root._entranceDoneTimeout);
          }
          root._entranceDoneTimeout = window.setTimeout(function () {
            root._entranceDoneTimeout = null;
            finishEntrance();
          }, entranceDoneMs());
        });
      });
    }

    revealEntrance();
    var intervalId = null;

    function stopAutoplay() {
      if (intervalId !== null) {
        clearInterval(intervalId);
        intervalId = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplayUnlocked || tiles.length <= 1 || prefersReducedMotion()) return;
      intervalId = setInterval(function () {
        if (document.hidden) return;
        var activeIndex = 0;
        for (var i = 0; i < tiles.length; i++) {
          if (tiles[i].classList.contains('is-active')) {
            activeIndex = i;
            break;
          }
        }
        setActive((activeIndex + 1) % tiles.length);
      }, getAutoplayMs(root));
    }

    function setActive(index) {
      var idx = parseInt(String(index), 10);
      if (isNaN(idx) || idx < 0 || idx >= tiles.length) return;

      var wasActive = -1;
      for (var a = 0; a < tiles.length; a++) {
        if (tiles[a].classList.contains('is-active')) {
          wasActive = a;
          break;
        }
      }
      if (wasActive === idx) return;

      tiles.forEach(function (tile, i) {
        var on = i === idx;
        tile.classList.toggle('is-active', on);
        tile.setAttribute('aria-pressed', on ? 'true' : 'false');
        tile.setAttribute('tabindex', on ? '0' : '-1');
      });

      if (canSwitchAnim && !prefersReducedMotion()) {
        root.classList.remove('media-switch--switching');
        if (root._msSwitchRaf1) {
          cancelAnimationFrame(root._msSwitchRaf1);
          root._msSwitchRaf1 = 0;
        }
        if (root._msSwitchRaf2) {
          cancelAnimationFrame(root._msSwitchRaf2);
          root._msSwitchRaf2 = 0;
        }
        root._msSwitchRaf1 = requestAnimationFrame(function () {
          root._msSwitchRaf1 = 0;
          root._msSwitchRaf2 = requestAnimationFrame(function () {
            root._msSwitchRaf2 = 0;
            root.classList.add('media-switch--switching');
            if (root._msSwitchTimeout) {
              window.clearTimeout(root._msSwitchTimeout);
            }
            root._msSwitchTimeout = window.setTimeout(function () {
              root.classList.remove('media-switch--switching');
              root._msSwitchTimeout = null;
            }, 450);
          });
        });
      }

      scheduleSyncActiveMedia(root);
      syncProductVideoTabindex(root);
    }

    function onVisibilityChange() {
      if (document.hidden) {
        stopAutoplay();
        pauseAllVideoLike(root);
        return;
      }
      if (autoplayUnlocked) startAutoplay();
      scheduleSyncActiveMedia(root);
    }

    function cleanup() {
      stopAutoplay();
      if (root._entranceDoneTimeout) {
        window.clearTimeout(root._entranceDoneTimeout);
        root._entranceDoneTimeout = null;
      }
      if (root._msSwitchTimeout) {
        window.clearTimeout(root._msSwitchTimeout);
        root._msSwitchTimeout = null;
      }
      if (root._msSwitchRaf1) {
        cancelAnimationFrame(root._msSwitchRaf1);
        root._msSwitchRaf1 = 0;
      }
      if (root._msSwitchRaf2) {
        cancelAnimationFrame(root._msSwitchRaf2);
        root._msSwitchRaf2 = 0;
      }
      if (root._mediaSwitchViewportIo) {
        try {
          root._mediaSwitchViewportIo.disconnect();
        } catch (e) {}
        root._mediaSwitchViewportIo = null;
      }
      root.classList.remove('media-switch--switching');
      if (sectionEl) {
        sectionEl.classList.remove('media-switch--ready', 'media-switch--entrance-done');
      }
      document.removeEventListener('visibilitychange', onVisibilityChange);
      if (root._mediaSwitchScrollUnlock) {
        window.removeEventListener('scroll', root._mediaSwitchScrollUnlock);
        root._mediaSwitchScrollUnlock = null;
      }
      if (root._mediaSwitchMotionQuery && root._mediaSwitchMotionHandler) {
        var mq = root._mediaSwitchMotionQuery;
        var mh = root._mediaSwitchMotionHandler;
        mq.removeEventListener('change', mh);
        root._mediaSwitchMotionQuery = null;
        root._mediaSwitchMotionHandler = null;
      }
      pauseAllVideoLike(root);
      if (root._mediaSwitchProductUrlCleanup) {
        root._mediaSwitchProductUrlCleanup();
        root._mediaSwitchProductUrlCleanup = null;
      }
      delete root.dataset.mediaSwitchReady;
    }

    root._mediaSwitchCleanup = cleanup;

    function onProductVideoHitClick(e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var hit = t.closest('[data-media-switch-product-destination]');
      if (!hit || !root.contains(hit)) return;
      var u = hit.getAttribute('data-media-switch-product-url');
      if (!u) return;
      e.stopPropagation();
      if (e.preventDefault) e.preventDefault();
      window.location.href = u;
    }

    function onProductVideoHitKey(e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var t = e.target;
      if (!t || !t.getAttribute) return;
      if (!t.hasAttribute('data-media-switch-product-destination')) return;
      e.preventDefault();
      e.stopPropagation();
      onProductVideoHitClick(e);
    }

    root.addEventListener('click', onProductVideoHitClick, true);
    root.addEventListener('keydown', onProductVideoHitKey, true);

    root._mediaSwitchProductUrlCleanup = function () {
      root.removeEventListener('click', onProductVideoHitClick, true);
      root.removeEventListener('keydown', onProductVideoHitKey, true);
    };

    tiles.forEach(function (tile) {
      tile.addEventListener('click', function () {
        setActive(tile.getAttribute('data-media-switch-tile'));
        startAutoplay();
      });
    });

    syncProductVideoTabindex(root);

    document.addEventListener('visibilitychange', onVisibilityChange);

    if (window.matchMedia) {
      var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      root._mediaSwitchMotionQuery = motionQuery;
      root._mediaSwitchMotionHandler = function () {
        if (prefersReducedMotion()) stopAutoplay();
        else if (autoplayUnlocked) startAutoplay();
      };
      motionQuery.addEventListener('change', root._mediaSwitchMotionHandler);
    }

    if (autoplayUnlocked) {
      startAutoplay();
    } else if (typeof IntersectionObserver === 'function' && sectionEl) {
      root._mediaSwitchViewportIo = new IntersectionObserver(
        function (entries) {
          for (var ei = 0; ei < entries.length; ei++) {
            if (entries[ei].isIntersecting) {
              unlockAutoplay();
              return;
            }
          }
        },
        { root: null, threshold: 0, rootMargin: '0px 0px 12% 0px' }
      );
      root._mediaSwitchViewportIo.observe(sectionEl);
    } else {
      root._mediaSwitchScrollUnlock = function () {
        if (getScrollY() > 0) unlockAutoplay();
      };
      window.addEventListener('scroll', root._mediaSwitchScrollUnlock, { passive: true });
    }
    scheduleSyncActiveMedia(root);
  }

  document.querySelectorAll('[data-media-switch]').forEach(init);

  document.addEventListener('shopify:section:load', function (ev) {
    var root = ev.target && ev.target.querySelector && ev.target.querySelector('[data-media-switch]');
    if (root) init(root);
  });

  document.addEventListener('shopify:section:unload', function (ev) {
    var section = ev.target;
    if (!section || !section.querySelector) return;
    var root = section.querySelector('[data-media-switch]');
    if (root && root._mediaSwitchCleanup) root._mediaSwitchCleanup();
  });
})();
